import { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
};

const ChartBarHorizontalIcon: FC<IProps> = ({
  width = 16,
  height = 16,
  color = "#1E3666",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 13.5V2.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 3.5H10.5V6.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 6.5H2.5V9.5H13.5V6.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 9.5V12.5H2.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChartBarHorizontalIcon;
